import React, { useState, useEffect } from 'react';
import {
    Box, Typography, TextField, Button, Table, TableBody, TableCell,
    TableContainer, TableHead, TableRow, Paper, Select, MenuItem,
    IconButton, Grid, Pagination, Dialog, DialogTitle, DialogContent,
    DialogActions
} from '@mui/material';
import { Edit, Delete, Add } from '@mui/icons-material';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { collection, addDoc, getDocs, updateDoc, deleteDoc, doc } from 'firebase/firestore';
import { db } from '../../firebase';
import Udhariheader from './Udhariheader';

const UdhariDene = () => {

    const [data, setData] = useState([]);
    const [search, setSearch] = useState('');
    const [page, setPage] = useState(1);
    const rowsPerPage = 5;

    // NEW FIELD: whatsapp
    const [form, setForm] = useState({
        id: null,
        nav: '',
        thikan: '',
        rakkam: '',
        dinank: '',
        method: 'Cash',
        whatsapp: 'NO'
    });

    const [openJamaDialog, setOpenJamaDialog] = useState(false);
    const [jamaForm, setJamaForm] = useState({
        id: null,
        udhariId: '',
        rakkam: '',
        dinank: '',
        haste: ''
    });
    const [jamaHistory, setJamaHistory] = useState([]);

    // Fetch data
    useEffect(() => {
        fetchData();
    }, []);

    const fetchData = async () => {
        try {
            const udhariSnap = await getDocs(collection(db, 'udhariDene'));
            const jamaSnap = await getDocs(collection(db, 'udhariJamaHistory'));

            const allJama = jamaSnap.docs.map(d => ({ id: d.id, ...d.data() }));

            const list = udhariSnap.docs.map(d => {
                const ud = { id: d.id, ...d.data() };
                const history = allJama.filter(j => j.udhariId === ud.id);

                const totalJama = history.reduce((sum, j) => sum + Number(j.rakkam || 0), 0);
                const remaining = Number(ud.rakkam || 0) - totalJama;

                return { ...ud, totalJama, remaining };
            });

            setData(list);

        } catch (err) {
            console.error(err);
            toast.error("डेटा लोड त्रुटी");
        }
    };

    // Save / Update
    const handleSave = async () => {
        if (!form.nav || !form.thikan || !form.rakkam || !form.dinank) {
            toast.error("सर्व फील्ड भरा!");
            return;
        }

        try {
            if (form.id) {
                await updateDoc(doc(db, "udhariDene", form.id), form);
                toast.info("डेटा अपडेट झाला");
            } else {
                await addDoc(collection(db, "udhariDene"), form);
                toast.success("नवीन नोंद जतन झाली");
            }
            handleReset();
            fetchData();
        } catch (err) {
            console.error(err);
            toast.error("जतन त्रुटी");
        }
    };

    const handleReset = () => {
        setForm({
            id: null,
            nav: '',
            thikan: '',
            rakkam: '',
            dinank: '',
            method: 'Cash',
            whatsapp: 'NO'
        });
    };

    const handleEdit = (row) => {
        setForm(row);
        window.scrollTo({ top: 0, behavior: "smooth" });
    };

    // Delete Udhari
    const handleDelete = async (id) => {
        try {
            await deleteDoc(doc(db, "udhariDene", id));
            toast.warn("नोंद हटवली");
            fetchData();
        } catch (err) {
            console.error(err);
            toast.error("हटवणे अयशस्वी!");
        }
    };

    // Open Jama Dialog
    const handleOpenJamaDialog = async (row) => {
        setJamaForm({ id: null, udhariId: row.id, rakkam: '', dinank: '', haste: '' });

        const snap = await getDocs(collection(db, 'udhariJamaHistory'));
        const history = snap.docs.map(d => ({ id: d.id, ...d.data() }))
            .filter(h => h.udhariId === row.id);

        setJamaHistory(history);
        setOpenJamaDialog(true);
    };

    // Save Jama
    const handleSaveJama = async () => {
        if (!jamaForm.rakkam || !jamaForm.dinank || !jamaForm.haste) {
            toast.error("सर्व फील्ड भरा!");
            return;
        }

        try {
            if (jamaForm.id) {
                await updateDoc(doc(db, "udhariJamaHistory", jamaForm.id), jamaForm);
                toast.info("जमा अपडेट");
            } else {
                await addDoc(collection(db, "udhariJamaHistory"), jamaForm);
                toast.success("जमा जतन");
            }

            handleOpenJamaDialog({ id: jamaForm.udhariId });
            fetchData();

        } catch (err) {
            console.error(err);
            toast.error("जमा त्रुटी!");
        }
    };

    // Delete Jama
    const handleDeleteJama = async (item) => {
        try {
            await deleteDoc(doc(db, "udhariJamaHistory", item.id));
            toast.warn("जमा हटवली");

            handleOpenJamaDialog({ id: item.udhariId });
            fetchData();

        } catch (err) {
            console.error(err);
            toast.error("हटवणे अपयशी!");
        }
    };

    // Search
    const filtered = data.filter(d =>
        d.nav.toLowerCase().includes(search.toLowerCase()) ||
        d.thikan.toLowerCase().includes(search.toLowerCase())
    );

    const pageData = filtered.slice((page - 1) * rowsPerPage, page * rowsPerPage);

    // UI
    return (
        <Box sx={{ p: 2 }}>

            <Udhariheader />

            {/* Form */}
            <Paper sx={{ p: 3, mb: 3 }}>
                <Typography variant="h6">उसणे देणे</Typography>

                <Grid container spacing={2} sx={{ mt: 1 }}>
                    <Grid item xs={12} md={2}>
                        <TextField
                            fullWidth label="नाव" size="small"
                            value={form.nav}
                            onChange={(e) => setForm({ ...form, nav: e.target.value })}
                        />
                    </Grid>

                    <Grid item xs={12} md={2}>
                        <TextField
                            fullWidth label="ठिकाण" size="small"
                            value={form.thikan}
                            onChange={(e) => setForm({ ...form, thikan: e.target.value })}
                        />
                    </Grid>

                    <Grid item xs={12} md={2}>
                        <TextField
                            fullWidth label="रक्कम" size="small" type="number"
                            value={form.rakkam}
                            onChange={(e) => setForm({ ...form, rakkam: e.target.value })}
                        />
                    </Grid>

                    <Grid item xs={12} md={2}>
                        <TextField
                            fullWidth label="दिनांक" size="small" type="date"
                            InputLabelProps={{ shrink: true }}
                            value={form.dinank}
                            onChange={(e) => setForm({ ...form, dinank: e.target.value })}
                        />
                    </Grid>

                    {/* Method */}
                    <Grid item xs={12} md={2}>
                        <Select fullWidth size="small"
                            value={form.method}
                            onChange={(e) => setForm({ ...form, method: e.target.value })}
                        >
                            <MenuItem value="Cash">Cash</MenuItem>
                            <MenuItem value="Online">Online</MenuItem>
                        </Select>
                    </Grid>

                    {/* NEW: WhatsApp Sent */}
                    <Grid item xs={12} md={2}>
                        <Select fullWidth size="small"
                            value={form.whatsapp}
                            onChange={(e) => setForm({ ...form, whatsapp: e.target.value })}
                        >
                            <MenuItem value="NO">NO</MenuItem>
                            <MenuItem value="YES">YES</MenuItem>
                        </Select>
                    </Grid>
                </Grid>

                <Box sx={{ mt: 2, textAlign: "right" }}>
                    <Button variant="contained" onClick={handleSave}>
                        {form.id ? "अपडेट करा" : "जतन करा"}
                    </Button>
                </Box>
            </Paper>

            {/* Search */}
            <TextField
                fullWidth size="small" label="शोधा..."
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                sx={{ mb: 2 }}
            />

            {/* Table */}
            <TableContainer component={Paper}>
                <Table>
                    <TableHead>
                        <TableRow sx={{ background: "#eee" }}>
                            <TableCell>Sr</TableCell>
                            <TableCell>नाव</TableCell>
                            <TableCell>ठिकाण</TableCell>
                            <TableCell>रक्कम</TableCell>
                            <TableCell>एकूण जमा</TableCell>
                            <TableCell>बाकी</TableCell>
                            <TableCell>दिनांक</TableCell>
                            <TableCell>पद्धत</TableCell>
                            <TableCell>WhatsApp</TableCell>
                            <TableCell>क्रिया</TableCell>
                        </TableRow>
                    </TableHead>

                    <TableBody>
                        {pageData.map((row, i) => (
                            <TableRow key={row.id}>
                                <TableCell>{(page - 1) * rowsPerPage + i + 1}</TableCell>
                                <TableCell>{row.nav}</TableCell>
                                <TableCell>{row.thikan}</TableCell>
                                <TableCell>₹{row.rakkam}</TableCell>
                                <TableCell style={{ color: 'green', fontWeight: 600 }}>₹{row.totalJama}</TableCell>
                                <TableCell style={{ color: row.remaining === 0 ? 'blue' : 'red', fontWeight: 600 }}>
                                    ₹{row.remaining}
                                </TableCell>
                                <TableCell>{row.dinank}</TableCell>
                                <TableCell>{row.method}</TableCell>

                                {/* SHOW WHATSAPP */}
                                <TableCell style={{ fontWeight: 600, color: row.whatsapp === "YES" ? "green" : "red" }}>
                                    {row.whatsapp}
                                </TableCell>

                                <TableCell>
                                    <IconButton onClick={() => handleEdit(row)}>
                                        <Edit />
                                    </IconButton>

                                    <IconButton color="error" onClick={() => handleDelete(row.id)}>
                                        <Delete />
                                    </IconButton>

                                    <IconButton color="primary" onClick={() => handleOpenJamaDialog(row)}>
                                        <Add />
                                    </IconButton>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>

            {/* Pagination */}
            <Pagination
                sx={{ mt: 2 }}
                page={page}
                count={Math.ceil(filtered.length / rowsPerPage)}
                onChange={(e, v) => setPage(v)}
            />

            {/* Jama Dialog */}
            <Dialog open={openJamaDialog} fullWidth onClose={() => setOpenJamaDialog(false)}>

                <DialogTitle>जमा करा</DialogTitle>

                <DialogContent sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>

                    <TextField size="small" label="रक्कम" type="number"
                        value={jamaForm.rakkam}
                        onChange={(e) => setJamaForm({ ...jamaForm, rakkam: e.target.value })}
                    />

                    <TextField size="small" label="दिनांक" type="date"
                        InputLabelProps={{ shrink: true }}
                        value={jamaForm.dinank}
                        onChange={(e) => setJamaForm({ ...jamaForm, dinank: e.target.value })}
                    />

                    <TextField size="small" label="हस्ते"
                        value={jamaForm.haste}
                        onChange={(e) => setJamaForm({ ...jamaForm, haste: e.target.value })}
                    />

                    <Typography variant="subtitle1">जमा इतिहास</Typography>

                    <Table size="small">
                        <TableBody>
                            {jamaHistory.length > 0 ? jamaHistory.map(h => (
                                <TableRow key={h.id}>

                                    <TableCell>₹{h.rakkam}</TableCell>
                                    <TableCell>{h.dinank}</TableCell>
                                    <TableCell>{h.haste}</TableCell>

                                    <TableCell>
                                        <IconButton onClick={() => setJamaForm(h)}>
                                            <Edit fontSize="small" />
                                        </IconButton>

                                        <IconButton color="error" onClick={() => handleDeleteJama(h)}>
                                            <Delete fontSize="small" />
                                        </IconButton>

                                    </TableCell>

                                </TableRow>
                            )) : (
                                <TableRow>
                                    <TableCell align="center">इतिहास नाही</TableCell>
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>

                </DialogContent>

                <DialogActions>
                    <Button onClick={() => setOpenJamaDialog(false)}>Close</Button>
                    <Button variant="contained" onClick={handleSaveJama}>
                        {jamaForm.id ? "अपडेट" : "जतन करा"}
                    </Button>
                </DialogActions>

            </Dialog>

            <ToastContainer />

        </Box>
    );
};

export default UdhariDene;
